// extracted by mini-css-extract-plugin
export var deleteIcon = "_p5-5";
export var deleteOption = "_p5-3";
export var divider = "_p5-2";
export var downloadIcon = "_p5-4";
export var drawer = "_p5-0";
export var drawerFooter = "_p5-6";
export var drawerOpen = "_p5-1";
export var highlighted = "_p5-7";
export var lighterHighlight = "_p5-8";